export const DAY_SKIP_KEYS = [
  { key: "monday", label: "M", day: 1 },
  { key: "tuesday", label: "T", day: 2 },
  { key: "wednesday", label: "W", day: 3 },
  { key: "thursday", label: "T", day: 4 },
  { key: "friday", label: "F", day: 5 },
  { key: "saturday", label: "S", day: 6 },
  { key: "sunday", label: "S", day: 0 },
];

export function normaliseDaysToSkip(daysToSkip = {}) {
  return {
    monday: !!daysToSkip.monday,
    tuesday: !!daysToSkip.tuesday,
    wednesday: !!daysToSkip.wednesday,
    thursday: !!daysToSkip.thursday,
    friday: !!daysToSkip.friday,
    saturday: !!daysToSkip.saturday,
    sunday: !!daysToSkip.sunday,
    publicHolidays: !!daysToSkip.publicHolidays,
  };
}

export function normaliseBuildersBreaks(buildersBreaks = [], count = buildersBreaks.length) {
  const targetCount = Math.max(0, Number(count) || 0);
  return Array.from({ length: targetCount }, (_, index) => {
    const existing = buildersBreaks[index] || {};
    return {
      id: existing.id || `builders-break-${index + 1}`,
      startDate: existing.startDate || "",
      durationDays:
        existing.durationDays === undefined || existing.durationDays === null
          ? ""
          : existing.durationDays,
    };
  });
}

function parseDate(value) {
  if (!value) return null;
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDate(date) {
  if (!date || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month, day);
}

function southAfricanPublicHolidaySet(year) {
  const dates = new Set();
  const add = (monthIndex, day) => {
    const date = new Date(year, monthIndex, day);
    dates.add(formatDate(date));
    if (date.getDay() === 0) dates.add(formatDate(addDays(date, 1)));
  };

  add(0, 1);
  add(2, 21);
  add(3, 27);
  add(4, 1);
  add(5, 16);
  add(7, 9);
  add(8, 24);
  add(11, 16);
  add(11, 25);
  add(11, 26);

  const easter = easterSunday(year);
  dates.add(formatDate(addDays(easter, -2)));
  dates.add(formatDate(addDays(easter, 1)));
  return dates;
}

function isPublicHoliday(date) {
  return southAfricanPublicHolidaySet(date.getFullYear()).has(formatDate(date));
}

function buildBuildersBreakDateSet(buildersBreaks = []) {
  const dates = new Set();
  buildersBreaks.forEach((item) => {
    const start = parseDate(item?.startDate);
    const duration = Math.max(0, Number(item?.durationDays) || 0);
    if (!start || duration <= 0) return;
    for (let offset = 0; offset < duration; offset += 1) {
      dates.add(formatDate(addDays(start, offset)));
    }
  });
  return dates;
}

export function isSkippedContractDate(date, project = {}) {
  const daysToSkip = normaliseDaysToSkip(project.daysToSkip || {});
  const weekday = date.getDay();
  const weekdaySkipped = DAY_SKIP_KEYS.some(
    (item) => item.day === weekday && daysToSkip[item.key]
  );
  if (weekdaySkipped) return true;
  if (daysToSkip.publicHolidays && isPublicHoliday(date)) return true;
  return buildBuildersBreakDateSet(project.buildersBreaks || []).has(formatDate(date));
}

export function calculateEstimatedEndDate(project = {}) {
  const start = parseDate(project.startDate);
  const duration = Math.max(0, Number(project.contractDurationDays) || 0);
  if (!start || duration <= 0) return "";
  return addContractDaysAfter(project.startDate, duration, project);
}

export function addContractDaysAfter(dateString, days, project = {}) {
  const start = parseDate(dateString);
  const duration = Math.max(0, Number(days) || 0);
  if (!start || duration <= 0) return dateString || "";

  const maxIterations = Math.max(duration * 20, 10000);
  let current = new Date(start);
  let remaining = duration;
  let iterations = 0;

  while (remaining > 0 && iterations < maxIterations) {
    current = addDays(current, 1);
    if (!isSkippedContractDate(current, project)) remaining -= 1;
    iterations += 1;
  }

  return formatDate(current);
}
